/**
 * Created by fworld on 2019/12/3.
 */
import request from '@/util/request'

export function faultAlarmUnion(data) {
    return request({
        url: '/api/v1/delivery/fault/union',
        method: 'get',
        params: data
    })
}


export function faultAlarmList(data) {
    return request({
        url: '/api/v1/delivery/fault/list',
        method: 'get',
        params: data
    })
}